import { ResourceEnum } from "src/constants/constants.ts";
import type { GridSortDirection } from "@mui/x-data-grid/models/gridSortModel";

export const defaultSelectSort: Record<string, string> = {
  [ResourceEnum.Country]: "name",
  [ResourceEnum.Currency]: "iso",
  [ResourceEnum.Customer]: "name",
  [ResourceEnum.Supplier]: "name",
  [ResourceEnum.Owner]: "company_name",
  [ResourceEnum.MarketingCompany]: "name",
  [ResourceEnum.BankAccount]: "name",
  [ResourceEnum.AccountingAccount]: "title",
  [ResourceEnum.Attribute]: "title",
  [ResourceEnum.SelectionListAttributeValue]: "title",
  [ResourceEnum.Category]: "title",
  [ResourceEnum.Condition]: "title",
  [ResourceEnum.CustomerGroup]: "title",
  [ResourceEnum.DeliveryMethod]: "title",
  [ResourceEnum.DeliveryService]: "title",
  [ResourceEnum.Discount]: "title",
  [ResourceEnum.DocumentTemplate]: "name",
  [ResourceEnum.Language]: "title",
  [ResourceEnum.Manufacturer]: "title",
  [ResourceEnum.PaymentMethod]: "title",
  [ResourceEnum.PriceList]: "title",
  [ResourceEnum.ProcessingTime]: "title",
  [ResourceEnum.Product]: "sku",
  [ResourceEnum.ProductGroup]: "title",
  [ResourceEnum.Role]: "name",
  [ResourceEnum.Unit]: "title",
  [ResourceEnum.User]: "name",
  [ResourceEnum.Variant]: "sku",
  [ResourceEnum.VoucherSerie]: "title",
  [ResourceEnum.Warehouse]: "title",
  [ResourceEnum.WarehousePlace]: "title",
};

export const SELECT_DEFAULT_LABEL_PROP = "title";
export const SELECT_DEFAULT_VALUE_PROP = "id";

export const defaultListSort: Record<
  string,
  Record<string, GridSortDirection>
> = {
  [ResourceEnum.AccountingPosting]: { source_document_date: "desc" },
  [ResourceEnum.Order]: { order_date: "desc" },
  [ResourceEnum.BankSepa]: { created_at: "desc" },
  [ResourceEnum.BankTransaction]: { date: "desc" },
  [ResourceEnum.AccountingPostingVacantPosition]: { document_date: "desc" },
  [ResourceEnum.AccountingPostingPosition]: { document_date: "desc" },
};
